import MuiThemeProvider from "components/MuiThemeProvider";
import PageInfoCardAdornment from "components/Layout/PageInfoCardAdornment";
import DataExportInfoCard from "../DataExportAthleteInfoCard";
import Constants from "config/Constants";
import { useTranslation } from "react-i18next";

function DataExportInfoCardAdornment() {
  const { t } = useTranslation();
  return (
    <PageInfoCardAdornment pageTitle={t(Constants.routes.exportData.titleKey)}>
      {(props) => (
        <MuiThemeProvider>
          <DataExportInfoCard onClose={props.onClose} />
        </MuiThemeProvider>
      )}
    </PageInfoCardAdornment>
  );
}

export default DataExportInfoCardAdornment;
